import { string, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { nameRegex } from '../../../../../utils/validation.js';
import { i as FIRST_NAME_MESSAGE, I as INCORRECT_NAME_MESSAGE, L as LAST_NAME_MESSAGE, a as INCORRECT_EMAIL_MESSAGE, E as EMAIL_REQUIRED_MESSAGE, j as EMPTY_MESSAGE_MESSAGE, k as EMPTY_SUBJECT_MESSAGE, n as PHONE_REQUIRED_MESSAGE, l as INVALID_PHONE_MESSAGE, h as CAPTCHA_REQUIRED_MESSAGE } from '../../../../../validation-AjMAVn7m.js';

const initialValues = {
    captcha: '',
    firstname: '',
    lastname: '',
    email: '',
    subject: '',
    message: '',
    telephone: '',
};

const getValidationSchema = (captcha = false) => {
    const validationSchema = {
        firstname: string().required(FIRST_NAME_MESSAGE).matches(nameRegex, INCORRECT_NAME_MESSAGE),
        lastname: string().required(LAST_NAME_MESSAGE).matches(nameRegex, INCORRECT_NAME_MESSAGE),
        email: string().trim().email(INCORRECT_EMAIL_MESSAGE).required(EMAIL_REQUIRED_MESSAGE),
        message: string().required(EMPTY_MESSAGE_MESSAGE),
        subject: string().required(EMPTY_SUBJECT_MESSAGE),
        telephone: string()
            .required(PHONE_REQUIRED_MESSAGE)
            .matches(/^[0-9\-+\s]{5,}$/g, INVALID_PHONE_MESSAGE),
        ...(captcha && {
            captcha: string().required(CAPTCHA_REQUIRED_MESSAGE),
        }),
    };
    return yupResolver(object().shape(validationSchema));
};

export { getValidationSchema, initialValues };
//# sourceMappingURL=index.js.map
